module.exports = __webpack_public_path__ + "img/bg_landing1.d51b9589.png";